import React from "react";
import UniversalForm from "../../../components/UniversalForm/UniversalForm";
import {
  useContactFormConfig,
  ContactFormProps,
} from "../../../components/UniversalForm/entityForms";

const ContactForm: React.FC<ContactFormProps> = (props) => {
  const config = useContactFormConfig(props);
  return (
    <>
      <style>{`
        .contact-form-responsive {
          max-width: 615px;
          margin: 0 auto;
        }

        @media (min-width: 1024px) {
          .contact-form-responsive {
            max-width: 922px;
          }
        }
      `}</style>
      <div className="contact-form-responsive">
        <UniversalForm config={config} />
      </div>
    </>
  );
};

export default ContactForm;
